import { render, staticRenderFns } from "./AddSocialPost.vue?vue&type=template&id=496b73b6&"
import script from "./AddSocialPost.vue?vue&type=script&lang=js&"
export * from "./AddSocialPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports